// extracted by mini-css-extract-plugin
export default {"modalBackground":"ModalBackground_modalBackground__gYjqR"};